/**
 * cfg
 */

import { cutDiffProportionAtom } from './atom'
import { createSliderInputComponent } from './_createSliderInputComponent'

const CutDiffProportion = createSliderInputComponent(
  {
    label: '步长比例',
    atom: cutDiffProportionAtom,
    helpContent: '绘画步数第一阶段占总步数的比例',
    min: 0.1,
    max: 0.9,
    step: 0.1,
    digits: 1,
  },
  'CutDiffProportion'
)

export { CutDiffProportion }
